export function isValidRandomPixKey(pix:string){
    if(pix.length!=36)
        return false;
    const r1=new RegExp('^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$');
    return r1.test(pix);
}